import { YamlUpdateStrategy } from '../../types';
import { UpdateStrategyValues } from '../../update-strategy';

/** 容器拉取策略转换成 yaml */
export const strategyToYaml = ({
  strategy,
  maxUnavailablePods,
  maxExtraPods,
  partition,
}: {
  strategy: UpdateStrategyValues;
  maxUnavailablePods?: string;
  maxExtraPods?: string;
  partition?: number;
}): YamlUpdateStrategy => {
  const { RECREATE, ROLLING_UPDATE, ON_DELETE } = UpdateStrategyValues;
  if (strategy === ON_DELETE) {
    return {
      type: ON_DELETE,
    };
  }
  if (strategy === RECREATE) {
    return {
      type: RECREATE,
    };
  }
  return {
    type: ROLLING_UPDATE,
    rollingUpdate: {
      maxUnavailable: maxUnavailablePods,
      maxSurge: maxExtraPods,
      partition,
    },
  };
};

export function yamlToStrategy(item: YamlUpdateStrategy): {
  strategy: UpdateStrategyValues;
  maxUnavailablePods?: string;
  maxExtraPods?: string;
  partition?: number;
} {
  const { RECREATE, ROLLING_UPDATE, ON_DELETE } = UpdateStrategyValues;
  if (item?.type === ON_DELETE) {
    return {
      strategy: ON_DELETE,
    };
  }
  if (item?.type === RECREATE) {
    return {
      strategy: RECREATE,
    };
  }
  return {
    strategy: ROLLING_UPDATE,
    maxUnavailablePods: item?.rollingUpdate?.maxUnavailable,
    maxExtraPods: item?.rollingUpdate?.maxSurge,
    partition: item?.rollingUpdate?.partition,
  };
}
